import { httpClient } from '../httpClient';

export const reportsApi = {
  getDashboard: (params) =>
    httpClient.get('/reports/dashboard', { params }),

  getPdplCompliance: (params) =>
    httpClient.get('/reports/pdpl-compliance', { params }),

  getDsrReport: (params) =>
    httpClient.get('/reports/dsr-report', { params }),

  getConsentReport: (params) =>
    httpClient.get('/reports/consent-report', { params }),

  exportPdpl: (params) =>
    httpClient.get('/reports/export/pdpl', { params, responseType: 'blob' }),

  exportDsr: (params) =>
    httpClient.get('/reports/export/dsr', { params, responseType: 'blob' }),
};
